import { useLayoutEffect, useState } from 'react';
import type { Node, PluginContainerData } from 'ricos-schema';

export const useImageDimensions = ({
  src,
  containerData,
  image,
}: {
  src: string | undefined;
  containerData: PluginContainerData;
  image: NonNullable<Node['imageData']>['image'];
}) => {
  const [dimensions, setDimensions] = useState<{
    width: number | undefined;
    height: number | undefined;
  }>({
    width: undefined,
    height: undefined,
  });

  const width = image?.width || Number(containerData?.width?.custom) || dimensions.width;
  const height = image?.height || Number(containerData?.height?.custom) || dimensions.height;

  useLayoutEffect(() => {
    if (typeof width === 'number' && typeof height === 'number') {
      return;
    }
    setDimensions({ width: undefined, height: undefined });
    if (!src) {
      return;
    }

    const newImg = new Image();
    newImg.onload = () => setDimensions({ width: newImg.width, height: newImg.height });
    newImg.src = src;

    return () => {
      newImg.onload = null;
    };
  }, [src]);

  return {
    width,
    height,
  };
};
